import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { upperFirst } from "lodash";
import {
  selectSite,
  searchBookingsQueryInput,
  searchAllDatesChange
} from "redux/app";
import Loader from "Loader";
import Notice from "Notice";
import Button from "Button";
import ListView from "./list-view-page/ListView";
import BookingFilterForm from "./list-view-page/BookingFilterForm";
import filterBookings from "./list-view-page/filterBookings";
import "./ListViewPage.css";
import {
  confirmStagedLoad,
  getSiteBookings,
  driverOffSite,
  checkOut,
  checkOutExportLoad,
  getDailyPalletInfo
} from "./list-view-page/list-view-queries";
import { format } from "date-fns";
import BookingPageTemplate from "./BookingPageTemplate";
import RightPanel from "RightPanel";
import { withErrorHandler } from "graphql-helper";
import CheckOutPanel from "./list-view-page/CheckOutPanel";
import Content from "../../../components/Content";
import Can from "Can";

function FilterBar({ appliedFilters, onShowFilters, onClearFilters }) {
  const filterName = k => upperFirst(k.replace(/([A-Z])/g, " $1"));
  return (
    <div className="table-filter-bar">
      {appliedFilters.length > 0 && (
        <div className="flex">
          {appliedFilters.map(([k, v]) => (
            <span key={k} className="capsule">
              <span className="capsule__title">{filterName(k)}:</span>
              {v.join(", ")}
            </span>
          ))}
          <span>
            <Button
              variant="white"
              size="tiny"
              title="Clear all"
              onClick={onClearFilters}
            />
          </span>
        </div>
      )}
      <Button
        variant="white"
        icon="filter_list"
        size="tiny"
        title="Filter"
        onClick={onShowFilters}
      />
    </div>
  );
}

class ListViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookings: [],
      bookingsLoading: true,
      panelOpen: false,
      showFilters: false,
      selectedBookingId: null,
      driverActions: "",
      appliedFilters: { includeInternal: false }
    };
  }

  componentDidMount() {
    if (parseInt(this.props.match.params.siteId) !== this.props.selectedSite) {
      let siteId = this.props.match.params.siteId;

      if (this.props.selectedSite === null && siteId !== null) {
        this.props.dispatch(selectSite(siteId));
      } else {
        siteId = this.props.selectedSite;
        this.updateRoute(this.props.selectedSite);
        this.fetchBookings();
        this.fetchDailyPalletInfo();
      }
    } else {
      this.fetchBookings();
      this.fetchDailyPalletInfo();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.match.params.siteId !== undefined &&
        prevProps.selectedSite !== parseInt(this.props.match.params.siteId)) ||
      prevProps.selectedDate !== this.props.selectedDate ||
      prevProps.searchBookingsQuery !== this.props.searchBookingsQuery ||
      prevProps.searchAllDates !== this.props.searchAllDates
    ) {
      this.fetchBookings();
      this.fetchDailyPalletInfo();
    } else if (prevProps.selectedSite !== this.props.selectedSite) {
      if (
        this.props.selectedSite &&
        parseInt(this.props.match.params.siteId) !== this.props.selectedSite
      ) {
        this.updateRoute(this.props.selectedSite);
        this.fetchBookings();
        this.fetchDailyPalletInfo();
      }
    }
  }

  updateRoute(id) {
    if (id === undefined || id === "") {
      this.props.history.push({ pathname: "/bookings/daily-bookings" });
    } else {
      this.props.history.push({
        pathname: `/bookings/site/${id}/daily-bookings`
      });
    }
  }

  fetchBookings() {
    const selectedSite = this.props.selectedSite || null;
    const includeInternal = true;

    getSiteBookings(
      selectedSite,
      this.props.searchAllDates
        ? null
        : format(this.props.selectedDate, "YYYY-MM-DD"),
      includeInternal,
      this.props.searchBookingsQuery
    ).then(data => {
      this.setState({ bookings: data.bookings, bookingsLoading: false });
    });
  }

  fetchDailyPalletInfo() {
    const selectedSite = this.props.selectedSite || null;
    getDailyPalletInfo(
      selectedSite,
      format(this.props.selectedDate, "YYYY-MM-DD")
    ).then(data => {
      this.setState({
        dailyPalletLimit: data.dailyPalletInfo.dailyPalletLimit,
        palletsForDate: data.dailyPalletInfo.palletsForDate
      });
    });
  }

  confirmDriverOffSite(id, direction) {
    driverOffSite(id, direction).then(() => {
      this.fetchBookings();
      this.setState({
        panelOpen: false,
        selectedBookingId: "",
        driverActions: ""
      });
    });
  }

  confirmStagedLoad(id) {
    confirmStagedLoad(id).then(() => {
      this.closePanel();
    });
  }

  confirmCheckOut(id, photo, vetCheckRequired, vetCheckPerformed) {
    if (!photo) {
      this.props.handleErrors(
        checkOut(id).then(() => {
          this.closePanel();
        })
      );
    } else {
      this.props.handleErrors(
        checkOutExportLoad(id, photo, vetCheckRequired, vetCheckPerformed).then(
          () => {
            this.closePanel();
          }
        )
      );
    }
  }

  driverActions(id, action) {
    this.setState({
      panelOpen: true,
      selectedBookingId: id,
      driverActions: action
    });
  }

  showDriverLocation(trailer) {
    this.setState({
      showMessage: true,
      message: `The driver is now checked in and should be instructed to park at: ${
        trailer.zone.name
      }${trailer.dock ? " - " + trailer.dock.number : ""}`
    });
  }

  dismissNotice() {
    this.setState({
      showMessage: false,
      message: ""
    });
  }

  closePanel() {
    this.setState({ panelOpen: false, selectedBookingId: null });
    this.fetchBookings();
  }

  handleFilterSubmit(appliedFilters) {
    this.setState({ appliedFilters, showFilters: false });
  }

  handleFilterReset() {
    this.setState({
      appliedFilters: { includeInternal: false },
      showFilters: false
    });
  }

  handleClearAllFilters() {
    this.setState({ appliedFilters: { includeInternal: false } });
  }

  get selectedBooking() {
    return this.state.bookings.find(b => b.id === this.state.selectedBookingId);
  }

  get filteredBookings() {
    return filterBookings(this.state.bookings, this.state.appliedFilters);
  }

  get appliedFiltersDisplay() {
    return Object.entries(this.state.appliedFilters)
      .filter(([, v]) => (Array.isArray(v) && v.length > 0) || v === true)
      .map(([k, values]) => {
        if (Array.isArray(values)) {
          return [k, values.map(v => v.label)];
        } else if (typeof values === "boolean") {
          return [k, ["Yes"]];
        }
        return [k, values];
      });
  }

  render() {
    if (this.state.isLoading || this.state.bookingsLoading) {
      return (
        <div className="calendar-view__loader">
          <Loader />
        </div>
      );
    }

    return (
      <BookingPageTemplate
        searchPlaceholder="Search bookings"
        showDateToggle={true}
        searchAllDates={this.props.searchAllDates}
        onSearchAllDatesChange={val => {
          this.props.dispatch(searchAllDatesChange(val));
        }}
        searchQuery={this.props.searchBookingsQuery}
        onSearchQueryChange={val =>
          this.props.dispatch(searchBookingsQueryInput(val))
        }
      >
        <RightPanel
          title={this.state.driverActions}
          isExpanded={this.state.panelOpen}
          onClose={this.closePanel.bind(this)}
        >
          <CheckOutPanel
            booking={this.selectedBooking}
            showPanel={this.state.showCheckOutPanel}
            onClose={this.closePanel.bind(this)}
            onConfirm={this.confirmCheckOut.bind(this)}
            action={this.state.driverActions}
            confirmDriverOffSite={this.confirmDriverOffSite.bind(this)}
            confirmStagedLoad={this.confirmStagedLoad.bind(this)}
            showDriverLocation={this.showDriverLocation.bind(this)}
          />
        </RightPanel>
        <RightPanel
          title="Filter Bookings"
          isExpanded={this.state.showFilters}
          onClose={() => {
            this.setState({ showFilters: false });
          }}
        >
          {this.state.showFilters && (
            <BookingFilterForm
              appliedFilters={this.state.appliedFilters}
              bookings={this.state.bookings}
              onSubmit={this.handleFilterSubmit.bind(this)}
              onReset={this.handleFilterReset.bind(this)}
            />
          )}
        </RightPanel>
        <Content>
          {this.state.showMessage && (
            <Notice
              onDismiss={this.dismissNotice.bind(this)}
              message={this.state.message}
            />
          )}
          <Can when="bookings.list.dailyPalletCount">
            {this.state.dailyPalletLimit > 0 && (
              <div className="dash-row">
                Pallets on this day: {this.state.palletsForDate}/
                {this.state.dailyPalletLimit}
              </div>
            )}
          </Can>
          <div className="dash-row">
            <div className="content-block">
              {!this.props.searchAllDates && (
                <h2>
                  Bookings -{" "}
                  {format(this.props.selectedDate, "dddd Do MMM YYYY")}
                </h2>
              )}
              <FilterBar
                appliedFilters={this.appliedFiltersDisplay}
                onClearFilters={this.handleClearAllFilters.bind(this)}
                onShowFilters={() => {
                  this.setState({ showFilters: true });
                }}
              />
              <ListView
                bookings={this.filteredBookings}
                bookingsLoading={this.state.bookingsLoading}
                selectedBooking={this.state.selectedBookingId}
                driverActions={this.driverActions.bind(this)}
              />
            </div>
          </div>
        </Content>
      </BookingPageTemplate>
    );
  }
}

function mapStateToProps({
  app: { selectedDate, selectedSite, searchBookingsQuery, searchAllDates },
  auth
}) {
  return {
    selectedDate,
    selectedSite,
    searchBookingsQuery,
    searchAllDates,
    auth
  };
}

export default withErrorHandler(
  withRouter(connect(mapStateToProps)(ListViewPage))
);
